import { ColumnHelperMethodType } from '../SearchContentTable.types';
import { TextCell } from '../components/TextCell';

export const ColumnComments: ColumnHelperMethodType = (columnHelper) =>
  columnHelper.accessor((row) => row.contentId, {
    id: 'comments',
    cell: ({ row }) => <TextCell>{row.original.comments}</TextCell>,
    header: () => <>Comments</>,
  });
